"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LegendItem = _interopRequireDefault(require("./LegendItem"));
var _Legend = _interopRequireDefault(require("./Legend.style"));
var _LegendPagination = _interopRequireDefault(require("./LegendPagination"));
var _excluded = ["items", "labelKey", "colors", "accentColor", "currency", "pageSize", "activeIndex", "highlightRow", "removeHighlight", "highlightActive", "onItemClick", "prefixId", "idKey", "withPagination", "withDescription", "withTextValue"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Legend = /*#__PURE__*/function (_Component) {
  _inherits(Legend, _Component);
  var _super = _createSuper(Legend);
  function Legend(props) {
    var _this;
    _classCallCheck(this, Legend);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "nextPage", function () {
      _this.setState(function (prevState) {
        return {
          currentPage: prevState.currentPage + 1
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "previousPage", function () {
      _this.setState(function (prevState) {
        return {
          currentPage: prevState.currentPage - 1
        };
      });
    });
    _this.state = {
      currentPage: 1
    };
    return _this;
  }
  _createClass(Legend, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        items = _this$props.items,
        labelKey = _this$props.labelKey,
        colors = _this$props.colors,
        accentColor = _this$props.accentColor,
        currency = _this$props.currency,
        pageSize = _this$props.pageSize,
        activeIndex = _this$props.activeIndex,
        highlightRow = _this$props.highlightRow,
        removeHighlight = _this$props.removeHighlight,
        highlightActive = _this$props.highlightActive,
        onItemClick = _this$props.onItemClick,
        prefixId = _this$props.prefixId,
        idKey = _this$props.idKey,
        withPagination = _this$props.withPagination,
        withDescription = _this$props.withDescription,
        withTextValue = _this$props.withTextValue,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var currentPage = this.state.currentPage;
      var pages = Math.ceil(items.length / pageSize);
      var hasPagination = withPagination && pages > 1;
      var currentItems = withPagination ? items.slice((currentPage - 1) * pageSize, currentPage * pageSize) : items;
      return /*#__PURE__*/_react["default"].createElement(_Legend["default"], _extends({
        id: prefixId ? "".concat(prefixId, "_legend") : 'legend',
        itemsCount: currentItems.length,
        accentColor: accentColor,
        hasPagination: hasPagination
      }, otherProps), currentItems.map(function (item, idx) {
        return /*#__PURE__*/_react["default"].createElement(_LegendItem["default"], {
          highlightRow: highlightRow,
          currency: item.template === 'percentage' ? '%' : item.currencyCode || currency,
          onMouseOver: _this2.props.highlightActive && function () {
            return _this2.props.highlightActive(item);
          },
          onFocus: _this2.props.highlightActive && function () {
            return _this2.props.highlightActive(item);
          },
          id: prefixId ? "".concat(prefixId, "LegendItem").concat(idx) : "legendItem".concat(idx),
          onMouseOut: _this2.props.removeHighlight && function () {
            return _this2.props.removeHighlight(item);
          },
          onBlur: _this2.props.removeHighlight && function () {
            return _this2.props.removeHighlight(item);
          },
          onClick: onItemClick(item[idKey]),
          label: item[labelKey] || '',
          value: item.isNegative ? -item.value : item.value,
          textValue: withTextValue && !item.isAmount ? item.text : '',
          description: withDescription && item.rewardDescription ? item.rewardDescription : '',
          percent: item.percentage,
          boxColor: colors && colors[(currentPage - 1) * pageSize + idx],
          key: item[idKey],
          active: activeIndex === item.orderIndex,
          template: item.template,
          isAmount: item.isAmount || item.template === 'percentage'
        });
      }), hasPagination && /*#__PURE__*/_react["default"].createElement(_LegendPagination["default"], {
        id: prefixId ? "".concat(prefixId, "LegendPagination") : 'legendPagination',
        nextPage: currentPage < pages && this.nextPage,
        previousPage: currentPage > 1 && this.previousPage
      }));
    }
  }]);
  return Legend;
}(_react.Component);
Legend.defaultProps = {
  labelKey: 'label',
  pageSize: 5,
  currency: 'EUR',
  activeIndex: -1,
  highlightRow: false,
  highlightActive: function highlightActive() {},
  removeHighlight: function removeHighlight() {},
  colors: null,
  accentColor: null,
  onItemClick: function onItemClick() {},
  prefixId: null,
  withPagination: false,
  withDescription: true,
  withTextValue: false
};
Legend.propTypes = {
  idKey: _propTypes["default"].string.isRequired,
  /** items to display in the legend */
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  /** Name of the label key of the data */
  labelKey: _propTypes["default"].string,
  /** array of colors to use for the color box of the legend items */
  colors: _propTypes["default"].arrayOf(_propTypes["default"].string),
  /** the color to use for various stying purposes */
  accentColor: _propTypes["default"].string,
  /** number of items to display per page */
  pageSize: _propTypes["default"].number,
  /** prefix the item id's */
  prefixId: _propTypes["default"].string,
  /** currency to display value with */
  currency: _propTypes["default"].string,
  /** index of the selected item in the legend */
  activeIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].shape({})]),
  /** if active, the LegendItem row will be highlighted on mouseenter */
  highlightRow: _propTypes["default"].bool,
  /** callback to update the selected index */
  highlightActive: _propTypes["default"].func,
  /** callback to reset the selected index */
  removeHighlight: _propTypes["default"].func,
  /** action on item click */
  onItemClick: _propTypes["default"].func,
  /** if active, the LegendPagination will be rendered */
  withPagination: _propTypes["default"].bool,
  /** if active, the description of the item will be rendered */
  withDescription: _propTypes["default"].bool,
  /** if active, the value of the a text only item will be rendered */
  withTextValue: _propTypes["default"].bool
};
Legend.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "nextPage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "previousPage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Legend",
  "props": {
    "labelKey": {
      "defaultValue": {
        "value": "'label'",
        "computed": false
      },
      "description": "Name of the label key of the data",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "pageSize": {
      "defaultValue": {
        "value": "5",
        "computed": false
      },
      "description": "number of items to display per page",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "currency": {
      "defaultValue": {
        "value": "'EUR'",
        "computed": false
      },
      "description": "currency to display value with",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "activeIndex": {
      "defaultValue": {
        "value": "-1",
        "computed": false
      },
      "description": "index of the selected item in the legend",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "shape",
          "value": {}
        }]
      },
      "required": false
    },
    "highlightRow": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "if active, the LegendItem row will be highlighted on mouseenter",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "highlightActive": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "callback to update the selected index",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "removeHighlight": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "callback to reset the selected index",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "colors": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "array of colors to use for the color box of the legend items",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "accentColor": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "the color to use for various stying purposes",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onItemClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "action on item click",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "prefixId": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "prefix the item id's",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "withPagination": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "if active, the LegendPagination will be rendered",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "withDescription": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "if active, the description of the item will be rendered",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "withTextValue": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "if active, the value of the a text only item will be rendered",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "idKey": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "items": {
      "description": "items to display in the legend",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": true
    }
  }
};
var _default = Legend;
exports["default"] = _default;